import { useBreadcrumb } from "components/breadcrumb/BreadcrumbContext";
import DealerCard from "../components/DealerCard";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import SEOMeta from "components/SEOMeta";
import { brandConfig } from "config/brandConfig";

export default function Dealers() {
  const { setItems } = useBreadcrumb();
  useEffect(() => {
    setItems([
      { label: "Accueil", href: "/" },
      { label: "Armuriers partenaires" },
    ]);
  }, [setItems]);

  return (
    <>
      <SEOMeta
        title="Liste de nos revendeurs"
        description={`Découvrez tous nos revendeurs d'armoires à fusils ${brandConfig.brandName} sécurisées, des armuriers partenaires prêts à vous conseiller et vous accompagner.`}
        canonicalPath="/revendeurs"
      />
      <h1>Revendeurs {brandConfig.brandName} – Armuriers partenaires</h1>
      <div className="grid" style={{ marginTop: 12 }}>
        <DealerCard
          name="M4Sécurité"
          location="94340 Cachan"
          website="https://m4s.com"
        />
      </div>
      <p className="color-product-desc">
        Les armoires à fusils KaiserSafe sont distribuées exclusivement via un
        réseau d’armuriers partenaires. Nos revendeurs vous accompagnent dans le
        choix du modèle, la conformité réglementaire et l’installation.
      </p>
      <p className="color-product-desc" style={{ marginTop: 12 }}>
        Vous êtes armurier et souhaitez rejoindre notre réseau de distribution ?{" "}
        <Link to="/contact">Contactez-nous</Link>.
      </p>
    </>
  );
}
